import { validateEnum } from "../core/Helpers";
export var GooglePayPaymentMethodTypeObj = {
    CARD: "CARD",
    PAYPAL: "PAYPAL",
};
export var validateGooglePayPaymentMethodType = function (googlePayPaymentMethodType) {
    return validateEnum(googlePayPaymentMethodType, GooglePayPaymentMethodTypeObj);
};
